<template>
  <section>
    <el-row>
      <el-col class="space">
        <CompanyList @comSelected="comSelected" :com-id="comId" :com-name="comName" :option="option" :is-disabled="disabled"></CompanyList>
      </el-col>
      <el-col class="space">
        <el-select  v-model="pId" placeholder="请选择项目" @change="proSelected" multiple :multiple-limit="limitSeleced">
          <el-option v-for="(item,index) in proData" :key="item.id" :label="item.proName" :value="item.id"></el-option>
        </el-select>
      </el-col>
      <el-col class="space">
        <el-select  v-model="rId" placeholder="请选择岗位" @change="roleSelected" multiple :multiple-limit="limitSeleced">
          <el-option v-for="(item,index) in roleData" :key="item.id" :label="item.roleName" :value="item.id"></el-option>
        </el-select>
      </el-col>
    </el-row>

  </section>
</template>

<script>
  import CompanyList from "../sysmanager/CompanyList";

  import {proSearch, roleParent,roleIsParent} from '../../api/api'

  export default {
    name: "LinkageRole",
    components: {CompanyList},
    props: {
      comId:null,
      comName:null,
      proId:Array,
      roleId:Array,
      option:0,
      limitSeleced:null,
    },
    data() {
      return {
        cId: null,
        proData: [],
        pId: [],
        roleData: [],
        rId: [],
        disabled:false,
      }
    },
    methods: {
      //更改公司时加载对应公司项目.岗位
      comSelected: function (id, value) {
        if (id != null) {
          this.cId = id; //公司编号
          //加载该公司下的所有项目包括 下级公司项目
          let params = {page: 1, limit: 10000, comId: id};//请求参数
          proSearch(params, this.GLOBAL.header).then(result => {
            if (result.success) {
              this.proData = result.data.result;
              if(this.option == 0){
                this.proClear();
                this.roleClear();
              }else {
                this.pId = this.proId;
                this.$emit('proSelected',this.pId);
              }

              //加载岗位
              let pd = null;
              if(this.pId !=null && this.pId.length>0)
              {
                pd = this.pId.join(',');
              }
              let roleParams = {comId: this.cId,proId:pd};//请求参数
              roleParent(roleParams, this.GLOBAL.header).then(result => {
                if (result.success) {
                  this.roleData = result.data;
                  if(this.option == 0){
                     //this.roleClear();
                  }else {
                    if(this.roleId !=0&& this.rId !=null){
                      this.rId = this.roleId;
                      this.$emit('roleSelected',this.rId);
                    }
                  }
                }
              });
            }
          });
        }
        this.$emit('comSelected',this.cId);
      },
      //更改项目时加载对应项目
      proSelected: function () {
        //加载岗位
        let pd = null;
        if(this.pId.length>0)
        {
          pd = this.pId.join(',');
        }
        let roleParams = {comId: this.cId,proId:pd};//请求参数
        roleParent(roleParams, this.GLOBAL.header).then(result => {
          if (result.success) {
            this.roleData = result.data;
            this.roleClear();
          }
        });
        this.$emit('proSelected',this.pId);
      },
      //更改角色
      roleSelected: function () {
        this.$emit('roleSelected',this.rId);
      },
      //清空项目
      proClear:function(){
        this.pId =null;
        this.$emit('proSelected',this.pId);
        return false;
      },
      //清空角色
      roleClear:function(){
        this.rId = null;
        this.$emit('roleSelected',this.rId);
        return false;
      }
    },
    mounted() {

    }
  }
</script>

<style scoped>
  .space {
    width: 200px;
    margin-right: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/LinkageRole.vue